import React, { useState } from 'react';
import { Layout, message, Table, Tag, Popconfirm, Typography } from 'antd';
import styles from './portalManagment.module.scss'; 
import TopHeader from '../TopHeader/TopHeader';
import PortalManagementForm from './PortalManagmentForm';

const PortalManagement = () => {
  return (
      <Layout className={styles.homeLayout}>
      <div className="aside-right-top-bar all-customer-topbar">
        <div className="top-bar-left">
          <div className="top_bar">
            <h3>Portal Management</h3>
          </div>
        </div>
        <div className="top-bar-right">
          <TopHeader />
        </div>
      </div>
      <div className={`${styles.container} portal-management-container`}>
        <PortalManagementForm />
      </div>
      <div className={styles.tableDiv}>
      </div>
    </Layout>
  );
};

export default PortalManagement;
